<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    @click:outside="resetPaymentMethod"
  >
    <v-card flat>
      <v-card-title>
        Edit Payment Method
        <v-spacer></v-spacer>
        <v-btn icon @click="resetPaymentMethod">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="method.expirationMonth"
                label="Expiration Month"
                :rules="[$rules.required, expirationMonthYearGreaterThanNow]"
                required
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="method.expirationYear"
                label="Expiration Year"
                :rules="[$rules.required, expirationYearNotInPast]"
                required
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="method.postalCode"
                label="Postal Code"
                :rules="[$rules.required, $rules.postalCode]"
                required
                outlined
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn :loading="saving" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "EditPaymentMethod",
  components: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    method: {}
  }),
  computed: {
    ...mapGetters({})
  },
  methods: {
    expirationYearNotInPast(v) {
      let year = parseInt(v);
      var currentYear = new Date().getFullYear();
      return year >= currentYear || "Expiration Year cannot be in the past";
    },
    expirationMonthYearGreaterThanNow() {
      var now = moment();
      var entered = moment(
        `${this.method.expirationYear}-${this.method.expirationMonth}-01`
      );

      return entered > now || "Expiration must be in the future";
    },
    resetPaymentMethod() {
      this.dialog = false;
      this.method = {};
    },
    showDialog(method) {
      this.method = Object.assign({}, method);
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("billing/updatePaymentMethod", this.method)
          .then(() => {
            this.$emit("save");

            this.$root.$snackbarSuccess("Payment method saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving a payment method."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
